/**
 * When the ride map frames the bike (and its route) again: a parking chosen as target (itinerary,
 * "Y aller"), another sheet, pause, the first position. Never because the bike moved: the rider may be panning the map, and
 * the locate button frames on demand.
 */
export function rideFrameKey(s: {
  hasView: boolean;
  hasBike: boolean;
  /** The chosen target parking (not the nearest one, which changes as the bike moves). */
  routeTo: string | undefined;
  guide: string | undefined;
  sheet: "start" | "info" | "ride";
  paused: boolean;
}): string {
  return [s.hasView, s.hasBike, s.routeTo ?? "", s.guide ?? "", s.sheet, s.paused].join("|");
}
